const kindMap: Record<string, string> = {
  实锤: 'bg-primary-100 text-primary-800 border-primary-200',
  辟谣: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  反转: 'bg-accent-100 text-accent-900 border-accent-200',
  待核实: 'bg-secondary-50 text-secondary-800 border-secondary-200',
  新进展: 'bg-accent-100 text-accent-800 border-accent-200',
  当事人回应: 'bg-primary-50 text-primary-700 border-primary-200',
  存疑: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  首爆: 'bg-primary-50 text-primary-700 border-primary-200',
  回应: 'bg-accent-100 text-accent-800 border-accent-200',
  自证: 'bg-primary-100 text-primary-800 border-primary-200',
  收束: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  预警: 'bg-primary-100 text-primary-800 border-primary-200',
};

export function StatusBadge({ label, className = '' }: { label: string; className?: string }) {
  const tone = kindMap[label] || 'bg-secondary-100 text-secondary-900 border-secondary-200';
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium ${tone} ${className}`}>
      {label}
    </span>
  );
}

export function SectionHead({
  eyebrow,
  title,
  desc,
  onDark = false,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  onDark?: boolean;
}) {
  return (
    <div className="flex flex-col gap-2">
      {eyebrow ? (
        <div className="flex items-center gap-2">
          <span className={`h-1.5 w-1.5 rounded-full ${onDark ? 'bg-accent-400' : 'bg-primary-500'}`} />
          <span className={`text-xs font-semibold tracking-widest uppercase ${onDark ? 'text-accent-300' : 'text-primary-600'}`}>
            {eyebrow}
          </span>
        </div>
      ) : null}
      <h2
        className={`font-heading text-2xl font-bold leading-tight md:text-3xl ${
          onDark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm leading-relaxed md:text-[15px] ${onDark ? 'text-background-100/80' : 'text-foreground-600'}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}

export function TrendIcon({ trend }: { trend: 'up' | 'down' | 'flat' }) {
  if (trend === 'up') {
    return (
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-arrow-up-line text-sm" />
      </span>
    );
  }
  if (trend === 'down') {
    return (
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className="ri-arrow-down-line text-sm" />
      </span>
    );
  }
  return (
    <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-background-200 text-foreground-500">
      <i className="ri-subtract-line text-sm" />
    </span>
  );
}

export const KIND_TABS = ['最新', '反转', '辟谣', '实锤', '待核实', '当事人回应'];